import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "route-form" }
const _hoisted_2 = { class: "title-form py-5 mb-6 flex items-center justify-between" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-field mb-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "kotaAsal" }, "Kota Asal", -1)
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = { class: "p-field mb-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { for: "kotaTujuan" }, "Kota Tujuan", -1)
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = { class: "p-col-12 mb-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "durasiPerjalananId" }, "Durasi Perjalanan", -1)
const _hoisted_13 = { class: "p-inputgroup mt-1" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon" }, "Jam", -1)
const _hoisted_15 = {
  key: 0,
  class: "p-error"
}
const _hoisted_16 = { class: "p-field mb-4" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { for: "hargaRetail" }, "Harga Retail", -1)
const _hoisted_18 = {
  key: 0,
  class: "p-error"
}
const _hoisted_19 = { class: "p-field mb-4" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { for: "hargaCompany" }, "Harga Company", -1)
const _hoisted_21 = {
  key: 0,
  class: "p-error"
}
const _hoisted_22 = {
  class: "btn-action w-full",
  style: {"position":"absolute","bottom":"10px"}
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h6", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_Multiselect, {
          id: "kotaAsal",
          class: "mt-1",
          modelValue: _ctx.v$.kotaAsalId.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.kotaAsalId.$model = $event)),
          placeholder: "Pilih Kota Asal",
          options: _ctx.kotaOption,
          searchable: true
        }, null, 8, ["modelValue", "options"]),
        ((_ctx.v$.kotaAsalId.$invalid && _ctx.submitted) || _ctx.v$.kotaAsalId.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_7, _toDisplayString(_ctx.v$.kotaAsalId.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_Multiselect, {
          id: "kotaTujuan",
          class: "mt-1",
          modelValue: _ctx.v$.kotaTujuanId.$model,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.kotaTujuanId.$model = $event)),
          placeholder: "Pilih Kota Tujuan",
          options: _ctx.kotaOption,
          searchable: true
        }, null, 8, ["modelValue", "options"]),
        ((_ctx.v$.kotaTujuanId.$invalid && _ctx.submitted) || _ctx.v$.kotaTujuanId.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_10, _toDisplayString(_ctx.v$.kotaTujuanId.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_InputText, {
            id: "durasiPerjalananId",
            modelValue: _ctx.v$.travelDuration.$model,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.travelDuration.$model = $event)),
            min: 0,
            type: "number"
          }, null, 8, ["modelValue"]),
          _hoisted_14
        ]),
        ((_ctx.v$.travelDuration.$invalid && _ctx.submitted) || _ctx.v$.travelDuration.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_15, _toDisplayString(_ctx.v$.travelDuration.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode(_component_Multiselect, {
          id: "hargaRetail",
          class: "mt-1",
          modelValue: _ctx.v$.hargaRetailId.$model,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.hargaRetailId.$model = $event)),
          placeholder: "Pilih Harga Retail",
          options: _ctx.hargaOption,
          searchable: true
        }, null, 8, ["modelValue", "options"]),
        ((_ctx.v$.hargaRetailId.$invalid && _ctx.submitted) || _ctx.v$.hargaRetailId.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_18, _toDisplayString(_ctx.v$.hargaRetailId.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_19, [
        _hoisted_20,
        _createVNode(_component_Multiselect, {
          id: "hargaCompany",
          class: "mt-1",
          modelValue: _ctx.v$.hargaCompanyId.$model,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.hargaCompanyId.$model = $event)),
          placeholder: "Pilih Harga Company",
          options: _ctx.hargaOption,
          searchable: true
        }, null, 8, ["modelValue", "options"]),
        ((_ctx.v$.hargaCompanyId.$invalid && _ctx.submitted) || _ctx.v$.hargaCompanyId.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_21, _toDisplayString(_ctx.v$.hargaCompanyId.required.$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_22, [
      _createVNode(_component_Button, {
        label: "Simpan",
        class: "font-semibold p-button-sm btn-primary px-10 mr-2",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)))
      }),
      _createVNode(_component_Button, {
        class: "btn-secondary text-black p-button-sm px-10 py-1",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeSidebar()))
      }, {
        default: _withCtx(() => [
          _hoisted_23
        ]),
        _: 1
      })
    ])
  ]))
}